// @flow
export default function find<T>(array: T[], cond: (T) => boolean ): ?T {
   for (let i = 0; i < array.length; i++) {
      const item = array[i];
      if (cond(item)) {
         return item;
      }
   }

   return null;
}
